export function race(...signals: (AbortSignal | undefined | null)[]): AbortSignal {
  const controller = new AbortController();

  function onAbort() {
    controller.abort();
  }

  for (const signal of signals) {
    if (signal) {
      if (signal.aborted) {
        return signal;
      } else {
        signal.addEventListener('abort', onAbort);
      }
    }
  }

  const resultingSignal = controller.signal;

  resultingSignal.addEventListener(
    'abort',
    () => {
      for (const signal of signals) {
        if (signal) {
          signal.removeEventListener('abort', onAbort);
        }
      }
    },
    {
      once: true,
    }
  );

  return resultingSignal;
}
